import React, { MutableRefObject, useEffect, useRef, useState } from "react";
import stylesPc from "./TimelineBar.module.css";
import stylesSp from "./TimelineBar_SP.module.css";
import { Clip } from "../../models/Timeline";
import { DragDropContext, Draggable, Droppable, DropResult } from "react-beautiful-dnd";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../root/RootReducer";
import {
    ClipMoveStarted,
    CutClip,
    DeleteClip,
    getFootageVideo,
    PauseTimeline,
    SetIsHandleKeyboard,
    UpdateTimelinePlayInfo,
    UpdateTimelineSourceIndex,
} from "../../store/actions/TimelineActions";
import { Button, makeStyles, createStyles, Modal, Slider, Mark } from "@material-ui/core";
import CutIcon from "../../../assets/image/cut.svg";
import CutRedIcon from "../../../assets/image/cutRed.svg";
import SelectIcon from "../../../assets/image/select.svg";
import SelectRedIcon from "../../../assets/image/selectRed.svg";
import DeleteIcon from "../../../assets/image/delete.svg";
import EditIcon from "../../../assets/image/edit.svg";
import SettingIcon from "../../../assets/image/setting.svg";
// import PartitionIcon from "../../../assets/image/partition.svg";
// import ChangeIcon from "../../../assets/image/change.svg";
// import VolumeIcon from "../../../assets/image/volume.svg";
// import SpeedIcon from "../../../assets/image/speed.svg";
// import MinusIcon from "../../../assets/image/scale01.svg";
// import PlusIcon from "../../../assets/image/scale02.svg";
import { typeList } from "../../models/Template";
import { GetTemplate } from "../../store/actions/TemplateActions";
import PuiTypography from "../../../components/elements/PuiTypography";
import { ArrowBackIos, Check } from "@material-ui/icons";
import { useInitFlag } from "../../../components/function/useInitFlag";
import EditClip from "./EditClip";
import CustomTimelineSetting from "./CustomTimelineSetting";
import { GetClipCurrentTime, GetCurrentClipIndexFromTime } from "../../../utils/TimelineUtils";
import { stringifyVideoTimeWithColons } from "../../../common/video/util/videoTimeStrings";
import { UpdateExportVideoInfo } from "../../store/actions/VideoInfoActions";
import { RESOLUTION, Bitrate, Resolution, FrameRate } from "../../models/video";
import PuiTooltip from "../../../components/elements/PuiTooltip ";
import { isNull } from "../../../utils/ObjectUtils";
import { t } from "i18next";
import { IsDevice } from "../../../components/function/useDeviceFlag";

/**
|--------------------------------------------------
| タイムラインバー
|--------------------------------------------------
*/

const useStyles = makeStyles(() =>
    createStyles({
        timelineSlider: {
            "&": {
                display: "block",
                zIndex: "11",
                marginBottom: "0",
                padding: "0",
                background: "rgb(28, 28, 28)",
            },
            "& .MuiSlider-rail": {
                height: "1px",
                opacity: "1",
                background: "#444",
            },
            "& .MuiSlider-track": {
                height: "1px",
                background: "#444",
            },
            "& .MuiSlider-markLabel": {
                userSelect: "none",
                cursor: "default",
                color: "#C6C6C6",
                opacity: "0.5",
                top: "15px",
                transform: "translateX(2px)",
            },
            "& .MuiSlider-mark": {
                width: "1px",
                height: "10px",
                background: "#444",
            },
            "& .MuiSlider-thumb": {
                background: "red",
            },
            '& .MuiSlider-thumb[data-index="1"]': {
                display: "none",
            },
        },
        isHidden: {
            display: "none",
        },
    })
);

interface TimelineBarProps {
    videoRefs: MutableRefObject<HTMLVideoElement[]>;
    handleReset: () => void;
    sourceIndex: number;
}

export default function TimelineBar({ videoRefs, handleReset }: TimelineBarProps) {
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : stylesSp;

    const dispatch = useDispatch();
    const classes = useStyles();

    const { user, exportVideoInfo } = useSelector((state: AppState) => ({
        user: state.user.user,
        exportVideoInfo: state.videoInfo.exportVideoInfo,
    }));
    const {
        clipList,
        sourceIndex,
        clipTimes,
        currentTime,
        totalTime,
        sourceLength,
        shootCutKeyId,
        isPlay,
        videoBitrate,
        videoWidth,
        videoHeight,
        videoFramerate,
        isAddClipToTimelineComplete,
    } = useSelector((state: AppState) => ({
        clipList: state.timeline.timeline?.clipList,
        sourceIndex: state.timeline.timelinePlayInfo.sourceIndex,
        clipTimes: state.timeline.timelinePlayInfo.clipTimes,
        currentTime: state.timeline.timelinePlayInfo.currentTime,
        totalTime: state.timeline.timelinePlayInfo.totalTime,
        sourceLength: state.timeline.timelinePlayInfo.sourceLength,
        shootCutKeyId: state.timeline.timelinePlayInfo.shootCutKeyId,
        isPlay: state.timeline.timelinePlayInfo.isPlay,
        videoBitrate: state.videoInfo.exportVideoInfo.bitrate,
        videoWidth: state.videoInfo.exportVideoInfo.width,
        videoHeight: state.videoInfo.exportVideoInfo.height,
        videoFramerate: state.videoInfo.exportVideoInfo.framerate,
        isAddClipToTimelineComplete: state.timeline.isAddClipToTimelineComplete,
    }));

    const [resolutionType, changeResolutionType] = useState<string>(RESOLUTION[1]);
    const [isOpenVerifyDeleteModal, ShowVerifyDeleteModal] = useState(false);
    const [selectedClipId, setSelectedClipId] = useState(0); //クリップを削除する為
    const [zoomMillis, setZoomMillis] = useState(30000);
    const [marks, setMarks] = useState<boolean | Mark[]>([]);
    const [isClipCutActive, setIsClipCutActive] = useState(false);

    // 設定ボタンを押下の場合、モーダル表示定義
    const [openUploadVideoModal, setOpenUploadVideoModal] = useState(false);
    //custom判定
    const [openCustom, setOpenCustom] = useState<boolean>(false);
    //解像度選択表示判定
    const [openVideoResolutionSelect, setOpenVideoResolutionSelect] = useState<boolean>(false);
    //フレームレート選択表示判定
    const [openVideoFramerateSelect, setOpenVideoFramerateSelect] = useState<boolean>(false);
    //ビットレート選択表示判定
    const [openVideoBitrateSelect, setOpenVideoBitrateSelect] = useState<boolean>(false);
    //設定でカスタムか判定
    const [isCustom, setIsCustom] = useState<boolean>(false);
    // 動画編集画面表示フラグ
    const [isEditModalOpen, setEditModalOpen] = useInitFlag();
    // 選択したクリップ
    const [selectedClip, setSelectedClip] = useState<Clip | null>();

    const refObject = useRef<HTMLDivElement>(null);
    const width = refObject.current?.getBoundingClientRect().width || 0;

    //クリップドラッグ可否flag
    const [isDragDisbled, changeIsDragDisbled] = useState<boolean>(true);

    // ビットレート
    const selectBitRate = (bitrate: string) => {
        setIsCustom(true);
        dispatch(
            UpdateExportVideoInfo({
                ...exportVideoInfo,
                bitrate: Number(bitrate),
            })
        );
    };

    // 解像度
    const selectResolution = (resolution: string) => {
        setIsCustom(true);
        const resolutionValue = resolution.split("×");
        dispatch(
            UpdateExportVideoInfo({
                ...exportVideoInfo,
                width: Number(resolutionValue[0]),
                height: Number(resolutionValue[1]),
            })
        );
    };

    // フレームレート
    const selectvideoFrameRate = (framerate: string) => {
        setIsCustom(true);
        dispatch(
            UpdateExportVideoInfo({
                ...exportVideoInfo,
                framerate: Number(framerate),
            })
        );
    };

    // ノイズ除去
    // const selectNoise = (event: any) => {
    //     const changeValue = JSON.parse(event.target.value.toLowerCase());
    //     setNoiseValue(changeValue);
    // };

    const onDragStart = () => {
        // setIsDraging(true);
        // videoRef.current?.pause();
    };

    // タイムラインをドラッグ&ドロップする時に実行
    const onDragEnd = (result: DropResult) => {
        const { source, destination } = result;
        // ドロップ領域(destination)を外れた場合は何もしない
        if (!destination || !source || !clipList) return;

        const newClipList: Clip[] = [...clipList];
        newClipList[source.index] = clipList[destination.index];
        newClipList[destination.index] = clipList[source.index];
        if (user) {
            dispatch(
                ClipMoveStarted(
                    newClipList[destination.index].id,
                    newClipList[source.index].seq,
                    Number(user.id)
                )
            );
        }
    };

    // タイムラインでクリップを押下する場合
    const handleClicktimeline = (
        clip: Clip,
        event: React.MouseEvent<HTMLDivElement, MouseEvent>
    ) => {
        if (!clip || !clip.id || !clipList) return;
        if (isClipCutActive) {
            //クリップを分割
            const clipIndex = clipList.findIndex((current) => current.id === clip.id);
            if (clipIndex !== -1 && event.currentTarget.parentElement) {
                const timelineWidth = event.currentTarget.parentElement.clientWidth;
                const clickPosition = event.clientX - 50; //クリックされた position（50はwindowsの左サイドまでの距離）
                let cutPointMillis =
                    Math.round(((clickPosition / timelineWidth) * totalTime) / 1000) * 1000;
                cutPointMillis = GetClipCurrentTime(cutPointMillis, clipTimes);

                if (user && cutPointMillis !== 0 && cutPointMillis !== clip.end - clip.start) {
                    dispatch(CutClip(clip.id, cutPointMillis, Number(user.id))); //クリップ分割API
                }
            }
        } else {
            //クリップの削除する為IDを設定
            setSelectedClipId(clip.id);
            setSelectedClip(clip);
        }
    };

    //削除ボタンを押下する場合、
    const handleClickClipDelete = () => {
        if (selectedClipId !== 0) {
            OpenVerifyDeleteModal();
        }
    };

    // 編集ボタンを押下する場合、
    const handleClickClipEdit = () => {
        if (selectedClip) {
            setEditModalOpen(true);
            dispatch(SetIsHandleKeyboard(false)); // 編集する際に、キーボードによるvideoのコントロールを無効にする
            dispatch(getFootageVideo(selectedClip.footageId));
        }
    };

    // 設定
    const handleClickSetting = (isOpen: boolean) => {
        setOpenUploadVideoModal(isOpen);
        setOpenCustom(false);
    };

    // 削除モーダルを表示
    const OpenVerifyDeleteModal = () => {
        ShowVerifyDeleteModal(true);
    };

    // 削除モーダルを閉じる
    const CloseVerifyDeleteModal = () => {
        ShowVerifyDeleteModal(false);
        // setSelectedClipId(0);
        // setSelectedClip(null);
    };

    // モーダルのOKボタンを押下の場合、
    const handleOKBtn = () => {
        if (user && selectedClipId !== 0) {
            //クリップを削除する
            dispatch(DeleteClip(selectedClipId, Number(user.id)));
            setSelectedClipId(0);
            setSelectedClip(null);
        }
        CloseVerifyDeleteModal();
    };

    // モーダルのキャンセルボタンを押下の場合、
    const handleCancelBtn = () => {
        CloseVerifyDeleteModal();
    };

    //分別アイコンを押下
    const handleClickClipCut = () => {
        if (isClipCutActive) return;
        setIsClipCutActive(!isClipCutActive);
        changeIsDragDisbled(false);
    };

    //ズームバーの移動
    // const zoomChange = (event: React.ChangeEvent<{}>, value: number | number[]) => {
    //     setZoomMillis(Number(value));
    //     handleResetMarks(Number(value));
    // };

    const handleChoiceIcon = () => {
        if (isDragDisbled) return;
        changeIsDragDisbled(!isDragDisbled);
        if (isClipCutActive) setIsClipCutActive(false);
    };

    const ChangeResolution = (
        bitrate: string,
        videoresolution: string,
        videoFramerate: string,
        type: string
    ) => {
        const resolutionValue = videoresolution.split("×");
        if (type !== "カスタム") {
            changeResolutionType(type);
        }
        if (type === "カスタム") {
            setOpenCustom(true);
        } else if (openCustom) {
            setOpenCustom(false);
        } else {
            setIsCustom(false);
        }

        dispatch(
            UpdateExportVideoInfo({
                ...exportVideoInfo,
                bitrate: Number(bitrate),
                width: Number(resolutionValue[0]),
                height: Number(resolutionValue[1]),
                framerate: Number(videoFramerate),
            })
        );
    };

    // タイムラインの時間表示進捗バーの移動が停止した場合
    const handleChangeCommitted = (event: React.ChangeEvent<{}>, value: number | number[]) => {
        if (isNull(value) || !clipList) return;

        // プレイを一時停止し、タイムラインの再生時間を更新
        const draggedTime = Math.round((value as number) / 1000) * 1000;

        // 移動先のクリップIndexをsourceIndexにし、クリップ再生時間を設定
        if (clipTimes && videoRefs) {
            // クリップのstartをリセットする
            handleReset();
            const currentClipIndex = GetCurrentClipIndexFromTime(
                draggedTime,
                clipTimes,
                sourceLength
            );
            const clipCurrentTime = GetClipCurrentTime(draggedTime, clipTimes);
            const video = videoRefs.current[currentClipIndex];
            const videoStartTime = clipList[currentClipIndex].start;
            if (video) {
                video.currentTime = Math.round((videoStartTime + clipCurrentTime) / 1000);
                if (isPlay) video.play();
            }

            if (sourceIndex !== currentClipIndex)
                dispatch(UpdateTimelineSourceIndex(currentClipIndex));
        }
    };

    // タイムラインの時間表示進捗バーを移動した場合
    const handleProgressBarChange = (event: React.ChangeEvent<{}>, value: number | number[]) => {
        if (
            isNull(value) ||
            !clipList ||
            Math.round((value as number) / 1000) * 1000 === currentTime
        )
            return;

        // プレイを一時停止し、タイムラインの再生時間を更新
        const draggedTime = Math.round((value as number) / 1000) * 1000;
        const isFinishedFlag = draggedTime === totalTime ? true : false;
        dispatch(UpdateTimelinePlayInfo(draggedTime, null, null, null, isFinishedFlag));

        // すべてのクリップを一時停止
        if (clipTimes && videoRefs) {
            for (let i = 0; i < videoRefs.current.length; i++) {
                videoRefs.current[i].pause();
            }
        }
    };

    // zoom仕様
    const handleResetMarks = (zoomMillisProps?: number) => {
        const defaultNum = 10;
        const createMarks: Mark[] = [];
        // 一旦コメントアウト
        // const zoomMillisData = zoomMillisProps || zoomMillis;
        // const zoom = totalTime / zoomMillisData;
        // const num = Math.round(defaultNum * zoom);
        // const marksNums = totalTime / 1000 < num ? totalTime / 1000 : num;
        const marksNums = totalTime / 1000 < defaultNum ? totalTime / 1000 : defaultNum;
        for (let i = 0; i <= marksNums; i++) {
            const value = (totalTime / marksNums) * i;
            // const value = (totalTime / num) * i;
            const label = stringifyVideoTimeWithColons(value);
            createMarks.push({
                value,
                label,
            });
        }
        setMarks(createMarks);
    };

    useEffect(() => {
        // テンプレート取得APIコール
        dispatch(GetTemplate(typeList));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (isAddClipToTimelineComplete) {
            dispatch(PauseTimeline());
            setSelectedClipId(0);
            setSelectedClip(null);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAddClipToTimelineComplete]);

    // ズームの初期値設定
    useEffect(() => {
        if (!totalTime) return;
        // 一旦対応、zoom機能が実装する際に削除
        setZoomMillis(totalTime);
        handleResetMarks();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [totalTime]);

    useEffect(() => {
        if (!clipList || clipList.length === 0) {
            setMarks([]);
            setSelectedClipId(0);
            setSelectedClip(null);
        }
    }, [clipList]);

    // キーボードによる操作（開発途中）
    useEffect(() => {
        handleClickSetting(false);
        switch (String(shootCutKeyId)) {
            // 「C」キーでカット
            // case "67":
            //     handleClickClipCut();
            //     break;

            // // 「E」キーで編集
            // case "69":
            //     handleClickClipEdit();
            //     break;

            // // 「S」キーで設定
            // case "83":
            //     handleClickSetting(true);
            //     break;

            // // 「V」キーでクリップの選択
            // case "86":
            //     handleChoiceIcon();
            //     break;

            // // 「✖️」キーで削除
            // case "8":
            //     handleClickClipDelete();
            //     break;

            default:
                break;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shootCutKeyId]);

    const CloseCustom = () => {
        setOpenCustom(false);
        setOpenVideoBitrateSelect(false);
        setOpenVideoResolutionSelect(false);
        setOpenVideoFramerateSelect(false);
    };

    return (
        <div
            // フッテージを読み込んでいない場合、動画コントロール操作を不可にする
            className={`${styles.root} ${
                !clipList || clipList.length === 0 ? styles.isBtnDisabled : ""
            }`}
        >
            {/* タイムラインツールエリア */}
            <div className={styles.timelineTool}>
                {/*選択 */}
                <div
                    className={styles.icon}
                    onClick={handleChoiceIcon}
                    style={{ cursor: !isDragDisbled ? "pointer" : "default" }}
                >
                    {isDragDisbled ? (
                        <img src={SelectRedIcon} alt="SelectIcon" />
                    ) : (
                        <img src={SelectIcon} alt="SelectIcon" />
                    )}
                    <div
                        className={styles.text}
                        style={{ color: isDragDisbled ? "#ff0000" : "var(--white)" }}
                    >
                        {t("選択")}
                    </div>
                </div>
                {/* カット */}
                <div
                    className={styles.icon}
                    onClick={handleClickClipCut}
                    style={{ cursor: !isClipCutActive ? "pointer" : "default" }}
                >
                    {isClipCutActive ? (
                        <img src={CutRedIcon} alt="cutIcon" />
                    ) : (
                        <img src={CutIcon} alt="cutIcon" />
                    )}
                    <div
                        className={styles.text}
                        style={{
                            minWidth: "40px",
                            color: isClipCutActive ? "#ff0000" : "var(--white)",
                        }}
                    >
                        {t("カット")}
                    </div>
                </div>
                {/* 分割 */}
                {/* <div className={styles.icon} style={{ opacity: "0.3" }}>
                    <img src={PartitionIcon} alt="PartitionIcon" />
                    <div className={styles.text}>分割</div>
                </div> */}
                {/*交代  */}
                {/* <div className={styles.icon} style={{ opacity: "0.3" }}>
                    <img src={ChangeIcon} alt="ChangeIcon" />
                    <div className={styles.text}>交代</div>
                </div> */}
                {/* 削除アイコン(クリップを選択している場合に表示する)*/}
                <div
                    className={styles.icon}
                    onClick={handleClickClipDelete}
                    style={{
                        cursor: selectedClipId !== 0 && !isClipCutActive ? "pointer" : "auto",
                        opacity: selectedClipId !== 0 && !isClipCutActive ? 1 : 0.3,
                        pointerEvents: isClipCutActive ? "none" : "auto",
                    }}
                >
                    <img src={DeleteIcon} alt="DeleteIcon" />
                    <div className={styles.text}> {t("削除")}</div>
                </div>
                <div
                    className={styles.icon}
                    onClick={handleClickClipEdit}
                    style={{
                        cursor: selectedClipId !== 0 && !isClipCutActive ? "pointer" : "auto",
                        opacity: selectedClipId !== 0 && !isClipCutActive ? 1 : 0.3,
                        pointerEvents: isClipCutActive ? "none" : "auto",
                    }}
                >
                    <img src={EditIcon} alt="EditIcon" />
                    <div className={styles.text}> {t("編集")}</div>
                </div>
                {/*音量 */}
                {/* <div className={styles.icon} style={{ opacity: "0.3" }}>
                    <img src={VolumeIcon} alt="VolumeIcon" />
                    <div className={styles.text}>音量</div>
                </div> */}
                {/*速度 */}
                {/* <div className={styles.icon} style={{ opacity: "0.3" }}>
                    <img src={SpeedIcon} alt="SpeedIcon" />
                    <div className={styles.text}>速度</div>
                </div> */}
                {/*設定 */}
                <div className={styles.icon} style={{ position: "relative" }}>
                    <div
                        onClick={() => handleClickSetting(!openUploadVideoModal)}
                        style={{ cursor: "pointer" }}
                    >
                        <img src={SettingIcon} alt="SpeedIcon" />
                        <div className={styles.text}> {t("設定")}</div>
                    </div>
                    {openUploadVideoModal && (
                        <div className={styles.rootDiv}>
                            <div className={styles.settingTitle}>
                                {openCustom && (
                                    <div onClick={CloseCustom}>
                                        <ArrowBackIos />
                                    </div>
                                )}
                                <PuiTypography size={14}>
                                    {openCustom ? t("カスタム") : t("動画設定")}
                                </PuiTypography>
                            </div>
                            {openCustom ? (
                                <CustomTimelineSetting
                                    selectResolution={selectResolution}
                                    selectvideoFrameRate={selectvideoFrameRate}
                                    selectBitRate={selectBitRate}
                                    openVideoResolutionSelect={openVideoResolutionSelect}
                                    setOpenVideoResolutionSelect={setOpenVideoResolutionSelect}
                                    openVideoFramerateSelect={openVideoFramerateSelect}
                                    setOpenVideoFramerateSelect={setOpenVideoFramerateSelect}
                                    openVideoBitrateSelect={openVideoBitrateSelect}
                                    setOpenVideoBitrateSelect={setOpenVideoBitrateSelect}
                                />
                            ) : (
                                <>
                                    <div className={styles.settingButton}>
                                        {RESOLUTION.map((item, index) => (
                                            <div
                                                key={index}
                                                className={
                                                    !isCustom && resolutionType === item
                                                        ? styles.activeButton
                                                        : styles.button
                                                }
                                                onClick={() =>
                                                    ChangeResolution(
                                                        Bitrate[index],
                                                        Resolution[index],
                                                        FrameRate[index],
                                                        item
                                                    )
                                                }
                                            >
                                                {!isCustom && resolutionType === item && <Check />}
                                                <PuiTypography size={14}>{item}</PuiTypography>
                                            </div>
                                        ))}
                                    </div>
                                    <div
                                        className={
                                            resolutionType === "カスタム"
                                                ? styles.activeCustom
                                                : styles.custom
                                        }
                                        onClick={() =>
                                            isCustom
                                                ? ChangeResolution(
                                                      String(videoBitrate),
                                                      `${videoWidth}×${videoHeight}`,
                                                      String(videoFramerate),
                                                      "カスタム"
                                                  )
                                                : ChangeResolution(
                                                      Bitrate[1],
                                                      Resolution[1],
                                                      FrameRate[1],
                                                      "カスタム"
                                                  )
                                        }
                                        style={{
                                            border: isCustom ? "1px solid #FFFFFFCC" : "none",
                                        }}
                                    >
                                        {isCustom && <Check />}
                                        <PuiTypography size={14}> {t("カスタム")}</PuiTypography>
                                    </div>
                                </>
                            )}
                            <div
                                className={styles.modalBg}
                                onClick={() => {
                                    setOpenUploadVideoModal(false);
                                }}
                            ></div>
                        </div>
                    )}
                </div>
                {/* 一旦機能を非表示にする */}
                {/* <div className={`${styles.zoomSlider} ${!(totalTime > 30000) ? styles.isDisabled : ""}`}>
                    <img src={MinusIcon} alt="MinusIcon"/>

                    <Slider
                        orientation="horizontal"
                        value={zoomMillis}
                        aria-label="volume"
                        max={totalTime}
                        min={30000}
                        step={1000}
                        style={{
                            marginLeft: "10px",
                            color: "white",
                            fontWeight: "bold",
                            marginRight: "10px",
                        }}
                        disabled={!(totalTime > 30000)}
                        onChange={zoomChange}
                    />

                    <img src={PlusIcon} alt="PlusIcon"/>
                </div> */}
            </div>
            <div ref={refObject} className={styles.timeline}>
                {/* タイムラインの時間表示 */}
                {/* <Slider
                    max={totalTime}
                    value={[currentTime, totalTime]}
                    getAriaLabel={() => "Minimum distance"}
                    onChange={handleProgressBarChange}
                    onChangeCommitted={handleChangeCommitted}
                    // step={totalTime / 10}
                    marks={marks}
                    style={{
                        width: (totalTime / zoomMillis) * width + "px",
                        color: "white",
                        fontWeight: "bold",
                    }}
                    className={`${classes.timelineSlider} ${totalTime === 0 ? classes.isHidden : ""}`}
                /> */}

                <Slider
                    min={0}
                    max={totalTime}
                    value={currentTime}
                    onChange={handleProgressBarChange}
                    onChangeCommitted={handleChangeCommitted}
                    marks={marks}
                    style={{
                        width: (totalTime / zoomMillis) * width + "px",
                        color: "white",
                        fontWeight: "bold",
                    }}
                    className={`${classes.timelineSlider} ${
                        totalTime === 0 ? classes.isHidden : ""
                    }`}
                />

                {totalTime === 0 && (
                    // タイムラインのダミ表示
                    <Slider
                        defaultValue={0}
                        step={10}
                        marks
                        min={0}
                        max={100}
                        className={classes.timelineSlider}
                    />
                )}
                {/* タイムラインバーエリア */}
                <DragDropContext onDragEnd={onDragEnd} onDragStart={onDragStart}>
                    <Droppable
                        droppableId="clipList"
                        direction="horizontal"
                        isDropDisabled={!isDragDisbled}
                    >
                        {(provided) => (
                            <div
                                className={styles.timelineBarArea}
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                                style={{
                                    background: "#1C1C1C",
                                    alignItems: "flex-end",
                                    width: (totalTime / zoomMillis) * width + "px",
                                    position: "relative",
                                }}
                            >
                                <div
                                    style={{
                                        position: "absolute",
                                        top: 0,
                                        left:
                                            totalTime === 0
                                                ? "0%"
                                                : (currentTime / totalTime) * 100 + "%",
                                        width: "1px",
                                        backgroundColor: "red",
                                        height: "100%",
                                        zIndex: 11,
                                    }}
                                />
                                {clipList &&
                                    clipList.length !== 0 &&
                                    clipList.map((clip, index) => (
                                        <Draggable
                                            key={clip.id}
                                            draggableId={String(clip.id)}
                                            index={index}
                                            isDragDisabled={!isDragDisbled}
                                        >
                                            {(provided) => (
                                                <div
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                    ref={provided.innerRef}
                                                    data-id={String(clip.id)}
                                                    data-seq={clip.seq}
                                                    data-start={clip.start}
                                                    data-end={clip.end}
                                                    className={
                                                        // clipがうまく読み込めない場合の対応
                                                        `${
                                                            clip.start === clip.end ||
                                                            clip.end === 0
                                                                ? styles.isError
                                                                : ""
                                                        } ${
                                                            selectedClipId === clip.id
                                                                ? styles.deleteClip
                                                                : styles.clip
                                                        } ${
                                                            isClipCutActive
                                                                ? styles.cutClip
                                                                : styles.clip
                                                        }`
                                                    }
                                                    style={{
                                                        // clipがうまく読み込めない場合の対応
                                                        // width: clip.start === 0 && clip.end === 0 ? "10%" : ((clip.end - clip.start) / zoomMillis) * 100 + "%",
                                                        width:
                                                            ((clip.end - clip.start) / zoomMillis) *
                                                                100 +
                                                            "%",
                                                        background: "#28233E",
                                                        height: "55px",
                                                        position: "relative",
                                                        // top: "10px",
                                                        ...provided.draggableProps.style,
                                                    }}
                                                    // data-index={index}
                                                    onClick={(event) =>
                                                        handleClicktimeline(clip, event)
                                                    }
                                                >
                                                    <div
                                                        data-tip={clip.fileName}
                                                        data-for={`title${clip.id}`}
                                                        style={{
                                                            position: "absolute",
                                                            top: "-25px",
                                                            width: "100%",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            whiteSpace: "nowrap",
                                                            fontWeight: 200,
                                                            fontSize: "14px",
                                                            opacity: 0.5,
                                                            textAlign: "left",
                                                        }}
                                                    >
                                                        {/* {`seq: ${clip.seq}, ${clip.fileName}`} */}
                                                        {clip.fileName}
                                                    </div>
                                                    <PuiTooltip
                                                        id={`title${clip.id}`}
                                                        place="left"
                                                    />
                                                </div>
                                            )}
                                        </Draggable>
                                    ))}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
            </div>

            {/* 削除確認モーダル表示 */}
            <Modal
                aria-labelledby="spring-modal-title"
                aria-describedby="spring-modal-description"
                open={isOpenVerifyDeleteModal}
                onClose={CloseVerifyDeleteModal}
                className={styles.deleteModal}
            >
                <div className={styles.deleteClipConfirmBox}>
                    <div className={styles.deleteClipConfirmBoxTitle}>
                        {t("選択したクリップを削除しますか")}
                    </div>
                    <div className={styles.deleteDiv}>
                        <Button
                            size="small"
                            variant="contained"
                            color="secondary"
                            className={styles.cancelBtnDiv}
                            onClick={handleCancelBtn}
                            style={{
                                marginRight: "20px",
                                color: "var(--white)",
                                background: "rgb(96, 96, 96)",
                            }}
                        >
                            {t("キャンセル")}
                        </Button>

                        <Button
                            size="small"
                            variant="contained"
                            color="secondary"
                            className={styles.deleteBtnDiv}
                            onClick={handleOKBtn}
                            style={{
                                color: "var(--white)",
                                background: "var(--studio-btn-bg)",
                            }}
                        >
                            {t("削除")}
                        </Button>
                    </div>
                </div>
            </Modal>
            {selectedClip && (
                <EditClip
                    isEditClipModalOpen={isEditModalOpen}
                    setEditClipModalOpen={setEditModalOpen}
                    clip={selectedClip}
                />
            )}
        </div>
    );
}
